import { WebPlugin } from '@capacitor/core';
const STORAGE_KEY = 'CapgoAppAttestKeyId';
const WEB_ERROR_MESSAGE = 'Native attestation is not available on web. Use iOS App Attest or Android Play Integrity.';
export class AppAttestWeb extends WebPlugin {
    async isSupported() {
        return {
            isSupported: false,
            platform: 'web',
            format: 'web-fallback',
        };
    }
    async getCapabilities() {
        return {
            platform: 'web',
            appAttest: { supported: false },
            playIntegrity: { supported: false },
            deviceCheck: { supported: false },
            widevine: {
                supported: false,
                fingerprintAvailable: false,
                securityLevelScanSupported: false,
            },
        };
    }
    async prepare(_options) {
        void _options;
        if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
            return {
                keyId: crypto.randomUUID(),
                platform: 'web',
                format: 'web-fallback',
            };
        }
        const keyId = `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        return {
            keyId,
            platform: 'web',
            format: 'web-fallback',
        };
    }
    async createAttestation(_options) {
        void _options;
        throw new Error(WEB_ERROR_MESSAGE);
    }
    async createAssertion(_options) {
        void _options;
        throw new Error(WEB_ERROR_MESSAGE);
    }
    async getWidevineFingerprint(_options) {
        void _options;
        throw new Error('Widevine fingerprinting is only available on Android.');
    }
    async getDeviceCheckToken() {
        throw new Error('DeviceCheck is only available on iOS.');
    }
    async storeKeyId(options) {
        localStorage.setItem(STORAGE_KEY, options.keyId);
        return { success: true };
    }
    async getStoredKeyId() {
        const keyId = localStorage.getItem(STORAGE_KEY);
        return {
            keyId,
            hasStoredKey: keyId !== null,
        };
    }
    async clearStoredKeyId() {
        localStorage.removeItem(STORAGE_KEY);
        return { success: true };
    }
    async generateKey(options) {
        return this.prepare(options);
    }
    async attestKey(options) {
        const result = await this.createAttestation(options);
        return Object.assign(Object.assign({}, result), { attestation: result.token });
    }
    async generateAssertion(options) {
        const result = await this.createAssertion(options);
        return Object.assign(Object.assign({}, result), { assertion: result.token });
    }
}
//# sourceMappingURL=web.js.map